import { useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

const EXIT_MS = 320;

export function Modal({
  onClose,
  sheetClass,
  children,
  closeDisabled = false,
  closeGutter = true,
  hideClose = false,
}: {
  onClose: () => void;
  sheetClass: string;
  children: (close: () => void) => ReactNode;
  closeDisabled?: boolean;
  closeGutter?: boolean;
  hideClose?: boolean;
}) {
  const [out, setOut] = useState(false);

  function close() {
    if (out || closeDisabled) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      onClose();
      return;
    }
    setOut(true);
    window.setTimeout(onClose, EXIT_MS);
  }

  return createPortal(
    <div className={out ? "crm-modal is-out" : "crm-modal"}>
      <div className={out ? `crm-sheet is-out relative ${!hideClose && closeGutter ? "!pr-12" : ""} ${sheetClass}` : `crm-sheet relative ${!hideClose && closeGutter ? "!pr-12" : ""} ${sheetClass}`} onMouseDown={(event) => event.stopPropagation()}>
        {hideClose ? null : (
          <button
            type="button"
            className="crm-modal-x absolute right-3 top-3 z-20 grid h-8 w-8 place-items-center rounded-full text-slate-500 hover:bg-black/5 disabled:pointer-events-none disabled:opacity-40"
            aria-label="Fermer"
            disabled={closeDisabled}
            onClick={close}
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
              <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        )}
        {children(close)}
      </div>
    </div>,
    document.body,
  );
}
